import React, { createContext, useState, useContext, useCallback } from "react";

const NewRecordsContext = createContext();

export const NewRecordsProvider = ({ children }) => {
  const [newRecords, setNewRecords] = useState({
    prescriptionFees: false,
    medicineOrderFees: false,
    laboratoryFees: false,
    ultrasoundFees: false,
    echoFees: false,
    xrayFees: false,
    emergencyFees: false,
  });

  const updateHighlight = useCallback((key, condition) => {
    setNewRecords((prev) => ({
      ...prev,
      [key]: condition,
    }));
  }, []);

  return (
    <NewRecordsContext.Provider value={{ newRecords, updateHighlight }}>
      {children}
    </NewRecordsContext.Provider>
  );
};

export const useNewRecords = () => useContext(NewRecordsContext);
